// raaqKaydi.js — RAAQ ERKEN UYARISI (21 Eki 2026)
//
// 🔑 Serkan: *"kaydı olmayan veya kategorisi olmayan meydan olamaz"* — iPad'de RAAQ o meydanın kartını kapatır (Build 77:
//    çapraz kırmızı örtü + CAPTAIN OVERRIDE). Planlamacı bunu uçuş gününe kalmadan görsün diye ASSIGN'da da uyarı
//    (*"olsa bence güzel olur"*): uçuş sektöründe DEP / DEST girilince şirketin `airport_risks` kaydına bakılır; kayıt ya da
//    kategori yoksa sektör satırının altında amber not. YALNIZ UYARI — kayıt engellenmez. DH ve SIM'de yok. Aynı form WHAT IF'te,
//    aynı not planlı görevin EDIT'inde. Okuma düşerse "RAAQ CHECK FAILED" (okunamadı ≠ yok — kayıt eksik DENMEZ).
import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

/** iPad ile AYNI kural (`RaaqRules.normalize`): kategori boşlukları atılıp büyük harfe çevrilince boşsa YOK. */
export const kategoriVar = (c) => String(c ?? '').trim().toUpperCase() !== '';

/** Meydanın RAAQ eksiği: 'NO RAAQ RECORD' · 'NO CATEGORY' · null (sorun yok). `kayitlar`: Map(ICAO → satır). */
export function raaqEksigi(icao, kayitlar) {
  const r = kayitlar.get(String(icao).toUpperCase());
  if (!r) return 'NO RAAQ RECORD';
  return kategoriVar(r.category) ? null : 'NO CATEGORY';
}

/** Geçerli ICAO'lar (4 harf), büyük harf, tekil — verilen sırayla (DEP önce, DEST sonra). */
export const raaqKodlari = (icaolar) => [...new Set((icaolar || [])
  .map(x => String(x || '').trim().toUpperCase()).filter(x => x.length === 4))];

/** Şirketin verilen meydanlar için RAAQ kayıtları. Dönen: { kayitlar: Map | null (okunuyor / okunamadı), hata, yenile }. */
export function useRaaqKayitlari(customerId, icaolar) {
  const anahtar = [...raaqKodlari(icaolar)].sort().join(',');   // sıra değişince yeniden okunmaz
  const [durum, setDurum] = useState({ anahtar: null, kayitlar: null, hata: null });
  const [deneme, setDeneme] = useState(0);
  useEffect(() => {
    if (!anahtar || !customerId) { setDurum({ anahtar, kayitlar: new Map(), hata: null }); return undefined; }
    let dead = false;
    const bitir = (kayitlar, hata) => { if (!dead) setDurum({ anahtar, kayitlar, hata }); };
    Promise.resolve(supabase.from('airport_risks').select('icao,category')
      .eq('customer_id', customerId).in('icao', anahtar.split(',')))
      .then(({ data, error }) => (error
        ? bitir(null, error.message || String(error))
        : bitir(new Map((data || []).map(r => [String(r.icao).toUpperCase(), r])), null)))
      .catch(e => bitir(null, e?.message || String(e)));
    return () => { dead = true; };
  }, [anahtar, customerId, deneme]);
  const guncel = durum.anahtar === anahtar;
  return { kayitlar: guncel ? durum.kayitlar : null, hata: guncel ? durum.hata : null, yenile: () => setDeneme(n => n + 1) };
}
